import axios from "axios";

//state
export var offertState = {
  offerts: [],
  offert: {},
  status_offert: ""
};

//getters
export var offertGetters = {
  //funciones para optener informacion del state
  getOfferts: state => state.offerts
};

//actions
export var offertActions = {
  async getOfferts({ commit }) {
    commit("offert_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var offerts = [
          { name: "oferta 10%", porcentaje: 10, id: 1 },
          { name: "oferta 40%", porcentaje: 40, id: 2 },
          { name: "oferta 70%", porcentaje: 70, id: 3 }
        ];
        commit("offert_success", offerts);
        return res;
      })
      .catch(err => {
        commit("offert_error");
        return err;
      });
  },
  async newOffert({ commit, state }, offert) {
    commit("offert_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var offerts = state.offerts;
        offerts.push(offert);
        commit("offert_success", offerts);
        return offerts;
      })
      .catch(err => {
        commit("campaign_error");
        return err;
      });
  },
  async editOffert({ commit, state }, offert) {
    commit("offert_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var offerts = state.offerts;
        var index = offerts.findIndex(element => {
          return element.id == offert.id;
        });
        offerts.splice(index, 1);
        offerts.splice(index, 0, offert);
        commit("offert_success", offerts);
        return offerts;
      })
      .catch(err => {
        commit("offert_error");
        return err;
      });
  }
};

//mutations

export var offertMutations = {
  offert_request(state) {
    state.status_offert = "loading";
  },
  offert_success(state, payload) {
    state.status_offert = "success";
    state.offerts = payload;
  },
  offert_error(state) {
    state.status_offert = "error";
  }
};
